/**
 * @itemgo/service-manwithvan
 * ItemGo Service Man With a Van Plugin
 */

import { manwithvanManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateManWithVanPricing } from "./services/pricing.js";
import { useManWithVanPricing } from "./hooks/useManWithVanPricing.js";
import { ManWithVanPricingBreakdown } from "./components/ManWithVanPricingBreakdown.js";

export { manwithvanManifest };

export const manwithvanPlugin: PluginModule = {
  manifest: manwithvanManifest,
  services: {
    calculatePrice: calculateManWithVanPricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useManWithVanPricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: ManWithVanPricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  ManWithVanPricingConfig,
  ManWithVanPricingInput,
  ManWithVanPricingResult,
  ManWithVanServiceData,
} from "./types.js";

// Schema
export { manwithvanSchema, itemTypes } from "./schema.js";
export type { ManWithVanFormData } from "./schema.js";

// Services
export {
  calculateManWithVanPricing,
  formatPence,
  DEFAULT_MANWITHVAN_PRICING_CONFIG,
} from "./services/pricing.js";

// React Hooks
export { useManWithVanPricing } from "./hooks/useManWithVanPricing.js";

// React Components
export { ManWithVanPricingBreakdown } from "./components/ManWithVanPricingBreakdown.js";
